import { destroyCookie } from "nookies";
import { TOKEN_STORAGE_KEY } from "./storeAuthorization";

export const removeAuthorization = (ctx?: any) => {
  destroyCookie(ctx, TOKEN_STORAGE_KEY);
};
